import {
  Create,
  Datagrid,
  Edit,
  List,
  Show,
  SimpleForm,
  SimpleShowLayout,
  TextField,
  UrlField,
  TextInput,
  required,
  Filter,
} from "react-admin";

export function ResourcesList(props: any) {
  return (
    <List
      {...props}
      filters={<ResourceFilter />}
      sort={{ field: "Title", order: "ASC" }}
    >
      <Datagrid rowClick="show">
        <TextField source="type" />
        <TextField source="title" />
        <TextField source="description" />
        <UrlField source="url" />
        <TextField source="alt" />
      </Datagrid>
    </List>
  );
}

export const ResourceCreate = (props: any) => (
  <Create {...props}>
    <SimpleForm redirect="list">
      <TextInput source="type" />
      <TextInput source="title" validate={[required()]} />
      <TextInput source="description" />
      <TextInput source="url" validate={[required()]} />
      <TextInput source="alt" />
    </SimpleForm>
  </Create>
);

export const ResourceShow = (props: any) => (
  <Show title="Resources details" {...props}>
    <SimpleShowLayout>
      <TextField source="type" />
      <TextField source="title" />
      <TextField source="description" />
      <UrlField source="url" />
      <TextField source="alt" />
    </SimpleShowLayout>
  </Show>
);

export const ResourceEdit = (props: any) => (
  <Edit title="Edit customer" {...props}>
    <SimpleForm redirect="list">
      <TextInput source="type" />
      <TextInput source="title" validate={[required()]} />
      <TextInput source="description" />
      <TextInput source="url" validate={[required()]} />
      <TextInput source="alt" />
    </SimpleForm>
  </Edit>
);

const ResourceFilter = (props: any) => (
  <Filter {...props}>
    <TextInput label="Search" source="search" alwaysOn variant="outlined" />
    <TextInput source="title" variant="outlined" />
    <TextInput source="description" label="Description" variant="outlined" />
    <TextInput source="url" variant="outlined" />
  </Filter>
);
